// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".ag-um-search-shareholder__empty-tile{padding-bottom:20px;display:flex;flex-direction:column;align-items:center;justify-content:center}.ag-um-search-shareholder__empty-tile p{margin-top:1rem;margin-bottom:2rem;font-size:1.125rem;color:#888}", ""]);
// Exports
module.exports = exports;
